import React from "react";
import { useFela } from "react-fela";
import useTranslation from "next-translate/useTranslation";

import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { useInquiryForm } from "@/hooks/useInquiryForm";
import { Button } from "@/components/Button";
import { FormSourceType } from "@/containers/InquiryForm";

export const BuyMoreCard: React.FC = () => {
  const { css } = useFela();
  const { colors } = useTheme();
  const { toggleInquiryForm } = useInquiryForm();

  const { t } = useTranslation("section/pricingFigmaBackup");

  return (
    <div
      className={css({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "32px 40px",
        marginTop: 24,
        color: colors.DARK_GREY,
        background: colors.WHITE,
        boxShadow: "20px 20px 80px rgba(16, 5, 48, 0.08)",
        borderRadius: 12,
      })}
    >
      <div className={css({ flexBasis: "55%" })}>
        <Heading as="h3" customStyle={{ marginBottom: 16 }}>
          {t("buyMoreCard.title")}
        </Heading>
        <p
          className={css({
            lineHeight: "24px",
          })}
        >
          {t("buyMoreCard.subtitle")}
        </p>
      </div>

      <div>
        <Button
          onClick={() => toggleInquiryForm(FormSourceType.BACKUP_MORE_INQUIRY)}
          customStyle={{ paddingLeft: 24, paddingRight: 24 }}
        >
          {t("common:contactSales")}
        </Button>
      </div>
    </div>
  );
};
